import React, { useCallback, useEffect, useRef, useState } from 'react';

import Socket from "@common/components/jackpot/service/signalR";
import JackpotCarousel from "@common/components/jackpot/carousel";

import './style.scss';

const JackpotCard = ({ openPopup, closePopup, theme, mode, betshopId, config }) => {
  const [state, setState] = useState({data: []});
  const stateRef = useRef(state);
  const listenersRef = useRef(new Set());

  const subscribeToJackpotState = useCallback((listener) => {
    if (typeof listener !== 'function') {
      return () => {};
    }

    listenersRef.current.add(listener);
    listener(stateRef.current);

    return () => {
      listenersRef.current.delete(listener);
    };
  }, []);

  useEffect(() => {
    stateRef.current = state;
    listenersRef.current.forEach((listener) => {
      listener(state);
    });
  }, [state]);

  useEffect(() => {
    if (!betshopId) return;
    let isMounted = true;

    const onUpdate = (updatePayload) => {
      if (!isMounted) return;
      const updatedData = updatePayload?.jackpots;

      if (updatedData) {
        setState(prev => {
          if (!prev?.data) return { ...prev, data: updatedData };

          const updatedExisting = prev.data.map(item => {
            const match = updatedData.find(u => u.levelId === item.levelId);
            return match ? { ...item, ...match } : item;
          });

          const newData = updatedData.filter(
            u => !prev.data.some(item => item.levelId === u.levelId)
          );
          return { ...prev, data: [...updatedExisting, ...newData] };
        });
      }
    };

    const init = async () => {
      try {
        const response = await fetch(`${config.jackpot.connectionUrl}/api/jackpot/jackpotupdateinfo`, {
          headers: { 'x-api-key': config.jackpot.apiKey, 'Content-Type': 'application/json' },
          method: 'POST',
          body: JSON.stringify(String(betshopId)),
        });
        const initialData = await response.json();

        if (isMounted) {
          setState(initialData);

          if (initialData?.data && initialData.data.length > 0) {
            Socket.subscribeToJackpot(+betshopId, onUpdate, config);
          }
        }
      } catch (error) {
        console.error(error);
      }
    };

    init();

    return () => {
      isMounted = false;
      Socket.unsubscribeFromJackpot(config);
    };
  }, [betshopId]);

  if (!state.data || !state.data.length) return null;

  return (
    <JackpotCarousel
      openPopup={openPopup}
      closePopup={closePopup}
      state={state}
      theme={theme}
      mode={mode}
      config={config}
      subscribeToJackpotState={subscribeToJackpotState}
    />
  );
};

export default JackpotCard;
